import { signOut } from 'modules/auth';

const customNoAuthResponse = (response: any): void => {
  console.devLog.info('No custom auth response needed on web');
  // Sign the user out
  signOut();
};

export default customNoAuthResponse;
